import { Panel } from 'models/Panel/Panel';
import { HyperSpaceAlerts } from '../widgets/HyperSpaceAlerts';
import { getWidgetAsPanelTemplate } from '../../utils/getWidgetAsPanelTemplate';

export const TemplateHyperSpaceAlerts: Panel = {
    id: 'hyper-space-alerts',
    name: 'Alerts',
    description: '',
    tags: ['AutoAlerts', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_hyper_space_alerts',
        children: [getWidgetAsPanelTemplate(HyperSpaceAlerts)],
        theme: {
            ext: {
                padding: 20,
            },
        },
    },
};
